var AbstractWS = require("./AbstractWS");

function StationUpdateWS(parent) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.method('POST');
  self.name = 'StationUpdateWS';			// Convenience name for debugging


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/station';
  });


  /**
   * Prototype overload
   * 
   * @method processData
   * @returns none
   */
  self.processData = function (data) {
    AbstractWS.prototype.processData.call(self, data);

    self.parent.checkStationWS.doRequest();
  }


  return self;
};

StationUpdateWS.prototype = AbstractWS.prototype;
StationUpdateWS.prototype.constructor = StationUpdateWS;

module.exports = StationUpdateWS
